import { __awaiter, __extends, __generator } from "tslib";
import cn from 'classnames';
import * as React from 'react';
import TextareaAutosize from 'react-autosize-textarea';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import { ChatMessageType } from '../../../../_library/domain-base/BaseChatMessage';
import { config } from '../../../_core/config';
import { getClientConfig } from '../../../_core/utils/app-storage';
import { createDebugLogger } from '../../../_core/utils/app-utils';
import { I18nMsgNs } from '../../../_core/utils/i18n-helpers';
import { domainSelector } from '../../../domain/domain-redux';
import './FreeText.scss';
import { CUSTOM_MESSAGE_ROOM_MARKER__SET_ENTITIES, CUSTOM_MESSAGE_TYPE_MARKER, } from '../../../../consts';
import { Cancel, UploadFileRounded } from '@mui/icons-material';
var KEY_CODE_ENTER = 13;
/** https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode#Constants_for_keyCode_value */
var CONTROL_KEYS = [
    9,
    16,
    17,
    18,
    20,
    37,
    38,
    39,
    40,
    91,
    93, // Opening context menu key.
];
var Msg = I18nMsgNs('FreeText');
var FreeTextClass = /** @class */ (function (_super) {
    __extends(FreeTextClass, _super);
    function FreeTextClass() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.debug = createDebugLogger('FreeText');
        _this.state = {
            value: '',
            file: null,
            error: '',
            placeholder: '',
        };
        _this._handleChange = function (e) {
            var MAX_INPUT_LENGTH = getClientConfig().MAX_INPUT_LENGTH;
            var value = e.currentTarget.value;
            if (MAX_INPUT_LENGTH)
                value = value.substring(0, MAX_INPUT_LENGTH);
            _this.setState({
                value: value,
            });
        };
        _this._handleKeyDown = function (e) {
            if (e.keyCode === KEY_CODE_ENTER && e.shiftKey === false) {
                e.preventDefault();
            }
        };
        _this._handleKeyUp = function (e) {
            if (e.keyCode === KEY_CODE_ENTER && e.shiftKey === false) {
                e.preventDefault();
                return _this.onSubmit();
            }
            // iba ak realne piseme, nie control keys...
            if (!CONTROL_KEYS.includes(e.keyCode)) {
                // always notify immediately - let's move the throttling/debouncing
                // responsibility to the consumer (so we're open to any implementation)
                _this._isTypingNotify();
                _this._stoppedTypingTimer && clearTimeout(_this._stoppedTypingTimer);
                _this._stoppedTypingTimer = setTimeout(_this._stoppedTypingNotify.bind(_this), FreeTextClass.STOPPED_TYPING_TIMEOUT);
            }
        };
        _this._handleSubmit = function (e) {
            e.preventDefault();
            _this.onSubmit();
        };
        _this.handleFileUpload = function (event) {
            event.preventDefault();
            var meta = _this.props.meta;
            var maxFileSize = (meta === null || meta === void 0 ? void 0 : meta.named_entities.max_file_size_allowed) || 4000000; // 4MB
            var file = event.target.files[0];
            if (file.size < maxFileSize) {
                _this.setState({
                    file: file,
                    placeholder: 'continueSendingFiles',
                });
            }
            else {
                _this.setState({
                    error: "Max file size allowed is ".concat(maxFileSize / 1000000, "MB"),
                    placeholder: '',
                });
                setTimeout(function () {
                    _this.setState({
                        error: '',
                        placeholder: '',
                    });
                }, 5000); // Hide after 5s
            }
        };
        return _this;
    }
    FreeTextClass.prototype.componentWillUnmount = function () {
        // delete window.__FREE_TEXT_INPUT_SET_VALUE;
        this._stoppedTypingTimer && clearTimeout(this._stoppedTypingTimer);
    };
    FreeTextClass.prototype._stoppedTypingNotify = function () {
        var onIsTyping = this.props.onIsTyping;
        onIsTyping && onIsTyping(false, this.state.value);
    };
    FreeTextClass.prototype._isTypingNotify = function () {
        var onIsTyping = this.props.onIsTyping;
        onIsTyping && onIsTyping(true, this.state.value);
    };
    FreeTextClass.prototype.onSubmit = function () {
        var _this = this;
        var _a;
        var meta = this.props.meta;
        var _b = this.state, value = _b.value, file = _b.file;
        var timeout = ((_a = meta === null || meta === void 0 ? void 0 : meta.named_entities) === null || _a === void 0 ? void 0 : _a.upload_timeout) || 30000; // Deafult: 30s
        if (typeof this.props.submitMessage === 'function') {
            // Send if file uploaded
            if (file) {
                var outerthis_1 = this;
                var reader = new FileReader();
                reader.readAsDataURL(file);
                this.setState({ file: null, placeholder: '' });
                reader.onload = function () { return __awaiter(_this, void 0, void 0, function () {
                    var base64;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                base64 = reader.result;
                                return [4 /*yield*/, outerthis_1.props.submitMessage(JSON.stringify({
                                        type: CUSTOM_MESSAGE_TYPE_MARKER,
                                        room: CUSTOM_MESSAGE_ROOM_MARKER__SET_ENTITIES,
                                        payload: {
                                            uploaded_document: base64,
                                            uploaded_document_name: file.name,
                                        },
                                    }), ChatMessageType.HIDDEN, { timeout: timeout })];
                            case 1:
                                _a.sent();
                                // Send utterance after document upload
                                this.setState({ value: '' });
                                this.props.submitMessage(value || this.i18n('uploadSuccessful'));
                                return [2 /*return*/];
                        }
                    });
                }); };
            }
            if (value.trim() && !file) {
                this.setState({ value: '' });
                this.props.submitMessage(value);
            }
        }
    };
    FreeTextClass.prototype.i18n = function (id, values, defaultMessage) {
        var intl = this.props.intl;
        return intl.formatMessage({ id: "FreeText.".concat(id), defaultMessage: defaultMessage }, values);
    };
    FreeTextClass.prototype.render = function () {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var _j = this.props, textareaMode = _j.textareaMode, meta = _j.meta, hidden = _j.hidden, intl = _j.intl;
        var disabled = ((_a = meta === null || meta === void 0 ? void 0 : meta.named_entities) === null || _a === void 0 ? void 0 : _a.isChatInputHidden) || this.props.disabled;
        if (hidden) {
            return null;
        }
        var B = config.css.B('-freetext');
        return (React.createElement(React.Fragment, null,
            ((_b = this === null || this === void 0 ? void 0 : this.state) === null || _b === void 0 ? void 0 : _b.file) && (React.createElement("div", { style: { width: '100%' } },
                React.createElement("div", { className: cn("".concat(B, "__upload-button-file-name")) },
                    React.createElement(UploadFileRounded, null),
                    React.createElement("div", null, (_d = (_c = this === null || this === void 0 ? void 0 : this.state) === null || _c === void 0 ? void 0 : _c.file) === null || _d === void 0 ? void 0 : _d.name),
                    React.createElement("span", { onClick: function () {
                            return _this.setState({ file: null, placeholder: '' });
                        } },
                        React.createElement(Cancel, null))))),
            !((_e = this === null || this === void 0 ? void 0 : this.state) === null || _e === void 0 ? void 0 : _e.file) && ((_f = this === null || this === void 0 ? void 0 : this.state) === null || _f === void 0 ? void 0 : _f.error) && (React.createElement("div", { className: cn("".concat(B, "__upload-button-file-error")) }, (_g = this === null || this === void 0 ? void 0 : this.state) === null || _g === void 0 ? void 0 : _g.error)),
            React.createElement("form", { onSubmit: this._handleSubmit, className: cn(B, this.state.value && "".concat(B, "__dirty")), id: "free-text-form" },
                ((_h = meta === null || meta === void 0 ? void 0 : meta.named_entities) === null || _h === void 0 ? void 0 : _h.allow_document_upload) && (React.createElement("div", { className: cn("".concat(B, "__upload-button")) },
                    React.createElement("input", { className: cn("".concat(B, "__upload-button-input")), type: "file", accept: ".txt, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .pdf, .jpg, .jpeg, .png, .bmp", onChange: this.handleFileUpload }))),
                React.createElement("div", { className: cn("".concat(B, "__input")) }, textareaMode ? this._renderTextarea() : this._renderInput()),
                React.createElement("div", { className: cn("".concat(B, "__buttons")) },
                    React.createElement(Button, { disabled: disabled || (!this.state.value.trim() && !this.state.file), type: "submit", color: "", className: "submit-button" },
                        React.createElement(Msg, { id: "submit" }))))));
    };
    FreeTextClass.prototype._renderInput = function () {
        var _a;
        var _b = this.props, placeholder = _b.placeholder, meta = _b.meta;
        var disabled = ((_a = meta === null || meta === void 0 ? void 0 : meta.named_entities) === null || _a === void 0 ? void 0 : _a.isChatInputHidden) || this.props.disabled;
        // prettier-ignore
        return (React.createElement("input", { autoComplete: "nope", name: "chat-input-text", type: "text", value: this.state.value, onChange: this._handleChange, placeholder: this.state.placeholder ? this.i18n(this.state.placeholder) : (placeholder || this.i18n(disabled ? 'placeholderDisabled' : 'placeholder')), autoFocus: true, onKeyUp: this._handleKeyUp, onKeyDown: this._handleKeyDown, disabled: disabled }));
    };
    FreeTextClass.prototype._renderTextarea = function () {
        var _a;
        var _b = this.props, placeholder = _b.placeholder, meta = _b.meta;
        var disabled = ((_a = meta === null || meta === void 0 ? void 0 : meta.named_entities) === null || _a === void 0 ? void 0 : _a.isChatInputHidden) || this.props.disabled;
        // prettier-ignore
        return (
        // @ts-ignore
        React.createElement(TextareaAutosize, { autoComplete: "nope", name: "chat-input-text", disabled: disabled, value: this.state.value, onChange: this._handleChange, placeholder: this.state.placeholder ? this.i18n(this.state.placeholder) : (placeholder || this.i18n(disabled ? 'placeholderDisabled' : 'placeholder')), autoFocus: true, rows: 1, maxRows: 4, onKeyUp: this._handleKeyUp, onKeyDown: this._handleKeyDown }));
    };
    FreeTextClass.defaultProps = {
        textareaMode: true,
    };
    // configurable via externals
    FreeTextClass.STOPPED_TYPING_TIMEOUT = 10000;
    return FreeTextClass;
}(React.Component));
export { FreeTextClass };
var mapStateToProps = function (state) {
    var uiState = domainSelector.getUIState(state);
    return {
        disabled: uiState.chat_input_disabled,
        hidden: uiState.chat_input_hidden,
    };
};
export var FreeText = connect(mapStateToProps)(injectIntl(FreeTextClass));
// lebo react-loadable s defaultnym exportom vyzaduje menej roboty
export default FreeText;
